import React, {ReactNode} from 'react';
import cn from 'classnames';

import styles from './TariffLimitGroup.module.scss';

interface ITariffLimitGroupProps {
    title: string;
    children?: ReactNode;
    className?: string;
}

const TariffLimitGroup: React.FC<ITariffLimitGroupProps> = ({title, children, className}) => (
    <div className={cn(styles.container, className)}>
        <div className={styles.title}>{title}</div>
        {children}
    </div>
);

export default TariffLimitGroup;
